import React from 'react'
import SocialLinks from "../components/SocialLinks";

export default function Footer() {
    return (
        <section className="footer">
            <SocialLinks />
            <div className="footer-btm">
                <p >#AbhishekNayak</p>
                <p>abhishek5nayak22@gmail.com</p>
            </div>
        </section>
    );
}
